import { getUserInfo } from '../store/userStore'

/**
 * API 服务层
 * 处理与后端的所有接口通信
 */

// 从环境变量获取API基础路径
const BASE_URL = import.meta.env.VITE_API_BASE_URL

// API 路径
const API_PATHS = {
  GET_PDA_LIST_PAGED: '/api/app/products/productsellfoxpurchaseorder/getpdalistpaged',
  GET_PUT_SHELF_LIST: '/api/app/products/productsellfoxpurchaseorderputaway/getlistpaged',
  GET_PURCHASE_ORDER: '/api/app/products/productsellfoxpurchaseorder/getpurchaseorderbyno',
  GET_PRODUCT_SKU_INFO: '/api/app/products/productasininfo/getproductasinsystemallsku',
  GET_FBA_ADJUSTMENT_SOURCE: '/api/app/products/productsellfoxpurchaseorderreturn/getfbaadjustmentsource',
  GET_FBA_ADJUSTMENT_LIST: '/api/app/products/productsellfoxpurchaseorderreturn/getlistpaged',
  GET_FBA_ADJUSTMENT_SKU: '/api/app/products/productsellfoxpurchaseorderreturn/getfbaadjustmentsku',
  SEARCH_FBA_ADJUSTMENT_SKU: '/api/app/products/productsellfoxpurchaseorderreturn/searchfbaadjustmentsku',
  CREATE_FBA_ADJUSTMENT: '/api/app/products/productsellfoxpurchaseorderreturn/createfbaadjustment',
  REMOVE_PDA_ARRIVAL_ITEM: '/api/app/products/productsellfoxpurchaseorder/removepdaarrivalitem',
  CONFIRM_PUT_SHELF: '/api/app/products/productsellfoxpurchaseorder/fbapurchasearrival',
  FBA_PURCHASE_ARRIVAL: '/api/app/products/productsellfoxpurchaseorder/purchasearrivastorage',
  GET_DING_USER_INFO: '/api/app/users/user/getdingusersinfo',
  GET_USER_VIEW_ALL: '/api/app/users/user/getviewall',
  GET_GOODS_LOCATION_ALL: '/api/app/chains/chaingoodslocation/getall',
  GET_LOCATION_TRANSFER_LIST: '/api/app/chains/chainwarehouseinventory/getlocationtransferlist',
  TRANSFER_LOCATION_FULL: '/api/app/chains/chainwarehouseinventory/transferlocationfull',
  GET_DESIGNATED_STATUS_DATA: '/api/app/chains/chainshipplan/getdesignatedstatusdata',
  CONFIRM_ALLOCATED: '/api/app/chains/chainshipplan/confirmallocated',
  GET_NEW_PDA_PICKING_LIST_PAGED: '/api/app/chains/chainnewshipment/getpdapickinglistpaged',
  CONFIRM_NEW_PDA_PICKING: '/api/app/chains/chainnewshipment/confirmpdapicking',
  GET_NEW_PDA_SMALL_LABEL_CHECK_LIST_PAGED: '/api/app/chains/chainnewshipment/getpdasmalllabelchecklistpaged',
  GET_NEW_PDA_SMALL_LABEL_CHECK_DETAIL: '/api/app/chains/chainnewshipment/getpdasmalllabelcheckdetail',
  SUBMIT_NEW_PDA_RETAINED_SAMPLES: '/api/app/chains/chainnewshipment/submitpdaretainedsamples',
  SUBMIT_NEW_PDA_SMALL_LABEL_FEEDBACK: '/api/app/chains/chainnewshipment/submitpdasmalllabelfeedback',
  GET_NEW_PDA_SECONDARY_PACKAGING_LIST_PAGED: '/api/app/chains/chainnewshipment/getpdasecondarypackaginglistpaged',
  GET_NEW_PDA_SECONDARY_PACKAGING_DETAIL: '/api/app/chains/chainnewshipment/getpdasecondarypackagingdetail',
  SUBMIT_NEW_PDA_SECONDARY_PACKAGING_FEEDBACK: '/api/app/chains/chainnewshipment/submitpdasecondarypackagingfeedback',
  SAVE_NEW_PDA_SKU_CHECK_IMAGES: '/api/app/chains/chainnewshipment/savepdaskucheckimages',
  PUSH_NEW_PDA_SKU_CHECK_IMAGES: '/api/app/chains/chainnewshipment/pushpdaskucheckimagemessage',
  GET_NEW_PDA_PACKING_LIST_PAGED: '/api/app/chains/chainnewshipment/getpdapackinglistpaged',
  GET_NEW_PDA_DELIVERY_ORDER_BOX_SIZE: '/api/app/chains/chainnewshipment/getpdadeliveryorderboxsize',
  SAVE_NEW_PDA_DELIVERY_ORDER_BOX_SIZE: '/api/app/chains/chainnewshipment/savepdadeliveryorderboxsize',
  CONFIRM_NEW_PDA_PACKING: '/api/app/chains/chainnewshipment/confirmpdapacking',
  GET_NEW_PDA_SHIPMENT_PLAN_BOX_SIZE: '/api/app/chains/chainnewshipment/getpdashipmentplanboxsize',
  GET_NEW_PDA_SHIPMENT_PLAN_BOX_RULE_CONTEXT: '/api/app/chains/chainnewshipment/getpdashipmentplanboxrulecontext',
  PREVIEW_NEW_PDA_BOX_RULE: '/api/app/chains/chainnewshipment/previewpdaboxrule',
  SAVE_NEW_PDA_SHIPMENT_PLAN_BOX_SIZE: '/api/app/chains/chainnewshipment/savepdashipmentplanboxsize',
  CONFIRM_NEW_PDA_SHIPMENT_PLAN_PACKING: '/api/app/chains/chainnewshipment/confirmpdashipmentplanpacking',
  GET_NEW_PDA_BOX_LABEL_LIST_PAGED: '/api/app/chains/chainnewshipment/getpdaboxlabellistpaged',
  CONFIRM_NEW_PDA_DELIVERY_ORDER_BOX_SIZE_LABEL: '/api/app/chains/chainnewshipment/confirmpdadeliveryorderboxsizelabel',
  CONFIRM_NEW_PDA_BOX_LABEL: '/api/app/chains/chainnewshipment/confirmpdaboxlabel',
  GET_NEW_DELIVERY_ORDER_LIST_PAGED: '/api/app/chains/chainnewshipment/getdeliveryorderlistpaged',
  CONFIRM_NEW_DELIVERY_ORDER_PICKING: '/api/app/chains/chainnewshipment/confirmdeliveryorderpicking',
  CONFIRM_PACKAGING: '/api/app/chains/chainshipplan/confirmpackaging',
  GET_PLAN_BOX_SIZE: '/api/app/chains/chainshipplan/getplanboxsize',
  CREATE_BOX_SIZE: '/api/app/chains/chainshipplan/createboxsize',
  MODIFY_BOX_SIZE: '/api/app/chains/chainshipplan/pdamodifyboxsize',
  REMOVE_BOX_SIZE: '/api/app/chains/chainshipplan/removeboxsize',
  UPLOAD_IMAGES: '/api/app/chains/chainshipplan/uploadimages',
  GET_PURCHASE_ORDER_STOCK_TAKE: '/api/app/products/productsellfoxpurchaseorder/getpurchaseorderstocktake',
  UPLOAD_INVENTORY_IMAGES: '/api/app/products/productsellfoxpurchaseorder/uploadimages',
  SUBMIT_STOCK_TAKE: '/api/app/products/productsellfoxpurchaseorder/purchaseordersubmitstocktake',
  GET_COMMODITY_STOCK_TAKE: '/api/app/products/productsellfoxcommodity/getcommoditystocktake',
  COMMODITY_SUBMIT_STOCK_TAKE: '/api/app/products/productsellfoxcommodity/commoditysubmitstocktake',
  GET_GOODS_NUMBER_LIST: '/api/app/products/productsellfoxpurchaseorder/getgoodsnumberlist',
  GET_GOODS_NUMBER_DETAILS: '/api/app/products/productsellfoxpurchaseorder/getgoodsnumberdetails',
  // 贴箱唛相关接口
  CONFIRM_BOX_SIZE_ATTACHED: '/api/app/chains/chainshipplan/confirmboxsizeattached',
  CONFIRM_ATTACHED: '/api/app/chains/chainshipplan/confirmattached',
  // 打包详情接口
  GET_PACKAGING_DETAILS: '/api/app/chains/chainshipplan/getpackagingdetails',
  //上传打包图片接口
  SAVE_SKU_CHECK_IMAGES: '/api/app/chains/chainshipplan/saveskucheckimages',
  // 推送图片到钉钉接口
  PUSH_IMAGES: '/api/app/chains/chainshipplan/pushskucheckimagemessage',
  // 获取货件列表
  GET_SHIP_PLAN_ITEM: '/api/app/chains/chainshipplan/getshipplanitem',
  // 货件确认打包
  SHIPMENT_CONFIRM_PACK: '/api/app/chains/chainshipplan/shipmentconfirmpack',
  // 运费提报 - 上传图片
  UPLOAD_FREIGHT_IMAGES: '/api/app/products/productfreightcostreport/uploadimages',
  // 运费提报 - 创建提报单
  CREATE_FREIGHT_REPORT: '/api/app/products/productfreightcostreport/create',
  // 备样模块
  GET_BEIYANG_LIST: '/api/app/chains/chainnewproductphotography/getlistpaged',
  GET_BEIYANG_DETAIL: '/api/app/chains/chainnewproductphotography/get',
  CONFIRM_PREPARE_SAMPLE: '/api/app/chains/chainnewproductphotography/warehousepreparesample',
  CONFIRM_WAREHOUSE_COMPLETE: '/api/app/chains/chainnewproductphotography/warehousecomplate',
  GET_OUTBOUND_HANDOVER_LIST: '/api/app/chains/chainnewshipment/getpdaoutboundhandoverlistpaged',
  GET_OUTBOUND_HANDOVER: '/api/app/chains/chainnewshipment/getoutboundhandover',
  GET_OUTBOUND_HANDOVER_UNSCANNED_BOXES: '/api/app/chains/chainnewshipment/getoutboundhandoverunscannedboxes',
  SCAN_OUTBOUND_HANDOVER: '/api/app/chains/chainnewshipment/scanoutboundhandover',
  REMOVE_OUTBOUND_HANDOVER_DELIVERY_ORDER: '/api/app/chains/chainnewshipment/removeoutboundhandoverdeliveryorder',
  CONFIRM_OUTBOUND_HANDOVER: '/api/app/chains/chainnewshipment/confirmoutboundhandover',
  CONFIRM_PHOTOGRAPHY_REVERT_SAMPLE: '/api/app/chains/chainnewproductphotography/photographyrevertsample',
  GET_CHANGSHA_PHOTOGRAPHY_LIST: '/api/app/products/productnewproductphotography/getpdalistpaged',
  GET_CHANGSHA_PHOTOGRAPHY_DETAIL: '/api/app/products/productnewproductphotography/getpdadetail',
  CONFIRM_CHANGSHA_PHOTOGRAPHY_RECEIVE: '/api/app/products/productnewproductphotography/confirmreceive',
  START_CHANGSHA_PHOTOGRAPHY_SHOOTING: '/api/app/products/productnewproductphotography/startshooting',
  REGISTER_CHANGSHA_PHOTOGRAPHY_TRANSFER: '/api/app/products/productnewproductphotography/registertransfer',
  MARK_CHANGSHA_PHOTOGRAPHY_SHOT: '/api/app/products/productnewproductphotography/markshot',
  UPLOAD_CHANGSHA_PHOTOGRAPHY_FILES: '/api/app/products/productnewproductphotography/uploadfiles',
  CONFIRM_CHANGSHA_PHOTOGRAPHY_UPLOAD: '/api/app/products/productnewproductphotography/confirmupload'
}

export async function getPdaOutboundHandoverList(params) {
  return request(API_PATHS.GET_OUTBOUND_HANDOVER_LIST, { body: JSON.stringify(params) })
}

export async function getProductSkuInfo(sku) {
  return request(API_PATHS.GET_PRODUCT_SKU_INFO, {
    body: JSON.stringify({ contentSearches: { searchType: 2, content: sku }, skipCount: 1, maxResultCount: 10 })
  })
}

export async function getComplaintPurchasers() {
  return request('/api/app/products/productpurchasetodo/getpurchasers', { method: 'GET' })
}

export async function searchFbaPurchaseOrders(keyword) {
  return request('/api/app/products/productpurchasetodo/searchfbapurchaseorders', {
    body: JSON.stringify({ keyword, maxResultCount: 20 })
  })
}

export async function getWarehouseComplaints(params) {
  return request('/api/app/products/productpurchasetodo/getcomplaints', { body: JSON.stringify(params) })
}

export async function createWarehouseComplaint(params) {
  return request('/api/app/products/productpurchasetodo/createcomplaint', { body: JSON.stringify(params) })
}

export async function withdrawWarehouseComplaint(params) {
  return request('/api/app/products/productpurchasetodo/withdrawcomplaint', { body: JSON.stringify(params) })
}

export async function getOutboundHandover(id) {
  return request(`${API_PATHS.GET_OUTBOUND_HANDOVER}?id=${encodeURIComponent(id)}`, { method: 'GET' })
}

export async function getOutboundHandoverUnscannedBoxes(id) {
  return request(`${API_PATHS.GET_OUTBOUND_HANDOVER_UNSCANNED_BOXES}?id=${encodeURIComponent(id)}`, { method: 'GET' })
}

export async function scanOutboundHandover(params) {
  return request(API_PATHS.SCAN_OUTBOUND_HANDOVER, { body: JSON.stringify(params) })
}

export async function removeOutboundHandoverDeliveryOrder(params) {
  return request(API_PATHS.REMOVE_OUTBOUND_HANDOVER_DELIVERY_ORDER, { body: JSON.stringify(params) })
}

export async function confirmOutboundHandover(params) {
  return request(API_PATHS.CONFIRM_OUTBOUND_HANDOVER, { body: JSON.stringify(params) })
}

/**
 * 通用请求方法
 */
async function request(url, options = {}) {
  const defaultOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  const config = { ...defaultOptions, ...options }

  if (config.method.toUpperCase() === 'GET') {
    delete config.body
    delete config.headers['Content-Type']
  }
  if (typeof FormData !== 'undefined' && config.body instanceof FormData) {
    delete config.headers['Content-Type']
  }

  try {
    const response = await fetch(BASE_URL + url, config)

    // 处理空响应或获取响应文本
    const text = await response.text()

    if (!response.ok) {
      // 尝试解析错误响应体
      let errorData = null
      try {
        errorData = text ? JSON.parse(text) : null
      } catch (e) {
        // 解析失败，使用原始文本
      }
      console.log(errorData)
      // 如果响应体中有code字段，优先使用
      if (errorData && errorData.error && errorData.error.code) {
        throw new Error(errorData.error.code)
      } else if (errorData && errorData.error && errorData.error.message) {
        throw new Error(errorData.error.message)
      } else {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
    }

    // 处理成功响应
    if (!text) {
      return { success: true }
    }
    return JSON.parse(text)
  } catch (error) {
    console.error('API请求失败:', error)
    throw error
  }
}


/**
 * 获取到货列表（分页）
 */
export async function getPdaListPaged(params) {
  return request(API_PATHS.GET_PDA_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取上架列表（分页）
 */
export async function getPutShelfList(params) {
  return request(API_PATHS.GET_PUT_SHELF_LIST, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 根据采购单号获取采购单信息
 */
export async function getPurchaseOrderByNo(purchaseNo) {
  if (!purchaseNo) {
    throw new Error('采购单号不能为空')
  }

  const url = `${API_PATHS.GET_PURCHASE_ORDER}?purchaseNo=${encodeURIComponent(purchaseNo)}`
  let result = await request(url, { method: 'GET' })
  // 兼容网关/ABP 对成功响应增加多层 data 或 result 包装的情况。
  for (let index = 0; index < 3; index++) {
    if (!result || typeof result !== 'object' || Array.isArray(result)) break
    if (result.purchaseNo || Array.isArray(result.items)) break
    if (result.data && typeof result.data === 'object') {
      result = result.data
    } else if (result.result && typeof result.result === 'object') {
      result = result.result
    } else {
      break
    }
  }
  return result
}

/**
 * 去除当前未上架的到货SKU
 */
export async function removePdaArrivalItem(params) {
  return request(API_PATHS.REMOVE_PDA_ARRIVAL_ITEM, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 调用FBA采购到货接口
 */
export async function fbaPurchaseArrival(params) {
  return request(API_PATHS.FBA_PURCHASE_ARRIVAL, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 根据采购单号获取可调整计划
 */
export async function getFbaAdjustmentSource(purchaseNo) {
  return request(`${API_PATHS.GET_FBA_ADJUSTMENT_SOURCE}?purchaseNo=${encodeURIComponent(purchaseNo)}`, {
    method: 'GET'
  })
}

/**
 * 获取PDA调整单列表
 */
export async function getFbaAdjustmentList(params) {
  return request(API_PATHS.GET_FBA_ADJUSTMENT_LIST, {
    body: JSON.stringify(params)
  })
}

/**
 * 获取替换SKU信息
 */
export async function getFbaAdjustmentSku(params) {
  return request(API_PATHS.GET_FBA_ADJUSTMENT_SKU, {
    body: JSON.stringify(params)
  })
}

/**
 * 模糊查询FBA调整可选SKU
 */
export async function searchFbaAdjustmentSku(params) {
  return request(API_PATHS.SEARCH_FBA_ADJUSTMENT_SKU, {
    body: JSON.stringify(params)
  })
}

/**
 * 提交FBA到货异常调整单
 */
export async function createFbaAdjustment(params) {
  return request(API_PATHS.CREATE_FBA_ADJUSTMENT, {
    body: JSON.stringify(params)
  })
}
/**
 * 确认上架
 */
export async function confirmPutShelf(params) {
  return request(API_PATHS.CONFIRM_PUT_SHELF, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取钉钉用户信息
 */
export async function getDingUserInfo(code) {
  if (!code) {
    throw new Error('免登code不能为空')
  }
  const url = `${API_PATHS.GET_DING_USER_INFO}?code=${encodeURIComponent(code)}`
  return request(url, { method: 'GET' })
}

export async function getUserViewAll() {
  let result = await request(API_PATHS.GET_USER_VIEW_ALL, { method: 'GET' })
  for (let index = 0; index < 3 && !Array.isArray(result); index++) {
    if (result && Array.isArray(result.data)) {
      result = result.data
    } else if (result && Array.isArray(result.result)) {
      result = result.result
    } else {
      break
    }
  }
  return Array.isArray(result) ? result : []
}

/**
 * 获取所有货位列表
 */
export async function getGoodsLocationAll() {
  return request(API_PATHS.GET_GOODS_LOCATION_ALL, {
    method: 'POST'
  })
}

export async function getLocationTransferList(params) {
  return request(API_PATHS.GET_LOCATION_TRANSFER_LIST, {
    method: 'POST',
    body: JSON.stringify(params || {})
  })
}

export async function transferLocationFull(params) {
  return request(API_PATHS.TRANSFER_LOCATION_FULL, {
    method: 'POST',
    body: JSON.stringify(params || {})
  })
}

/**
 * 获取指定状态的发货计划数据（配货/打包）
 */
export async function getDesignatedStatusData(params) {
  return request(API_PATHS.GET_DESIGNATED_STATUS_DATA, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 确认配货
 */
export async function confirmAllocated(ids, userId, userName) {
  return request(API_PATHS.CONFIRM_ALLOCATED, {
    method: 'POST',
    body: JSON.stringify({
      ids,
      userId: userId || '',
      userName: userName || ''
    })
  })
}

/**
 * 获取新版PDA配货列表（按发货计划）
 */
export async function getNewPdaPickingListPaged(params) {
  return request(API_PATHS.GET_NEW_PDA_PICKING_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function getNewPdaPickingDetail(id) {
  const url = `/api/app/chains/chainnewshipment/getpdapickingdetail?id=${encodeURIComponent(id)}`
  return request(url, { method: 'GET' })
}

/**
 * 确认新版PDA配货（按发货计划）
 */
export async function confirmNewPdaPicking(ids, userId = null, userName = '系统后台', items = [], saveOnly = false) {
  return request(API_PATHS.CONFIRM_NEW_PDA_PICKING, {
    method: 'POST',
    body: JSON.stringify({
      ids,
      userId: userId || null,
      userName: userName || '系统后台',
      items,
      saveOnly
    })
  })
}

/**
 * 获取新版PDA核对小标列表（按发货计划）
 */
export async function getNewPdaSmallLabelCheckListPaged(params) {
  return request(API_PATHS.GET_NEW_PDA_SMALL_LABEL_CHECK_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取新版PDA核对小标详情
 */
export async function getNewPdaSmallLabelCheckDetail(id) {
  const url = `${API_PATHS.GET_NEW_PDA_SMALL_LABEL_CHECK_DETAIL}?id=${encodeURIComponent(id)}`
  return request(url, { method: 'GET' })
}

/**
 * PDA统一提交SKU是否留样
 */
export async function submitNewPdaRetainedSamples(params) {
  return request(API_PATHS.SUBMIT_NEW_PDA_RETAINED_SAMPLES, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 提交PDA小标二次核对问题反馈
 */
export async function submitNewPdaSmallLabelFeedback(params) {
  return request(API_PATHS.SUBMIT_NEW_PDA_SMALL_LABEL_FEEDBACK, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取PDA二次包装包材不匹配列表。
 */
export async function getNewPdaSecondaryPackagingListPaged(params) {
  return request(API_PATHS.GET_NEW_PDA_SECONDARY_PACKAGING_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取PDA二次包装包材不匹配详情。
 */
export async function getNewPdaSecondaryPackagingDetail(id) {
  return request(`${API_PATHS.GET_NEW_PDA_SECONDARY_PACKAGING_DETAIL}?id=${encodeURIComponent(id)}`, { method: 'GET' })
}

/**
 * 提交PDA二次包装包材不匹配反馈。
 */
export async function submitNewPdaSecondaryPackagingFeedback(params) {
  return request(API_PATHS.SUBMIT_NEW_PDA_SECONDARY_PACKAGING_FEEDBACK, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 保存新版PDA SKU核对图片
 */
export async function saveNewPdaSkuCheckImages(params) {
  return request(API_PATHS.SAVE_NEW_PDA_SKU_CHECK_IMAGES, {
    method: 'POST',
    body: JSON.stringify({
      ...params,
      userId: params?.userId || null,
      userName: params?.userName || '系统后台'
    })
  })
}

/**
 * 推送新版PDA SKU核对图片到钉钉
 */
export async function pushNewPdaSkuCheckImages(id, userId = null, userName = '系统后台') {
  return request(API_PATHS.PUSH_NEW_PDA_SKU_CHECK_IMAGES, {
    method: 'POST',
    body: JSON.stringify({
      id,
      userId: userId || null,
      userName: userName || '系统后台'
    })
  })
}

/**
 * 获取新版PDA打包列表（按发货计划）
 */
export async function getNewPdaPackingListPaged(params) {
  return request(API_PATHS.GET_NEW_PDA_PACKING_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取新版PDA发货单箱规
 */
export async function getNewPdaDeliveryOrderBoxSize(deliveryOrderId) {
  const url = `${API_PATHS.GET_NEW_PDA_DELIVERY_ORDER_BOX_SIZE}?deliveryOrderId=${encodeURIComponent(deliveryOrderId)}`
  return request(url, { method: 'GET' })
}

/**
 * 保存新版PDA发货单箱规
 */
export async function saveNewPdaDeliveryOrderBoxSize(params) {
  return request(API_PATHS.SAVE_NEW_PDA_DELIVERY_ORDER_BOX_SIZE, {
    method: 'POST',
    body: JSON.stringify({
      ...params,
      userId: params?.userId || null,
      userName: params?.userName || '系统后台'
    })
  })
}

/**
 * 确认新版PDA发货单打包
 */
export async function confirmNewPdaPacking(ids, remark = '', userId = null, userName = '系统后台') {
  return request(API_PATHS.CONFIRM_NEW_PDA_PACKING, {
    method: 'POST',
    body: JSON.stringify({
      ids,
      remark,
      userId: userId || null,
      userName: userName || '系统后台'
    })
  })
}

/**
 * 获取新版PDA发货计划箱规
 */
export async function getNewPdaShipmentPlanBoxSize(shipmentPlanId) {
  const url = `${API_PATHS.GET_NEW_PDA_SHIPMENT_PLAN_BOX_SIZE}?shipmentPlanId=${encodeURIComponent(shipmentPlanId)}`
  return request(url, { method: 'GET' })
}

/**
 * 获取发货计划下各货件的物流渠道箱规限制。
 */
export async function getNewPdaShipmentPlanBoxRuleContext(shipmentPlanId) {
  const url = `${API_PATHS.GET_NEW_PDA_SHIPMENT_PLAN_BOX_RULE_CONTEXT}?shipmentPlanId=${encodeURIComponent(shipmentPlanId)}`
  return request(url, { method: 'GET' })
}

/**
 * 实时预览单箱物流渠道箱规校验结果。
 */
export async function previewNewPdaBoxRule(params) {
  return request(API_PATHS.PREVIEW_NEW_PDA_BOX_RULE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 保存新版PDA发货计划箱规
 */
export async function saveNewPdaShipmentPlanBoxSize(params) {
  return request(API_PATHS.SAVE_NEW_PDA_SHIPMENT_PLAN_BOX_SIZE, {
    method: 'POST',
    body: JSON.stringify({
      ...params,
      userId: params?.userId || null,
      userName: params?.userName || '系统后台'
    })
  })
}

/**
 * 确认新版PDA发货计划打包
 */
export async function confirmNewPdaShipmentPlanPacking(shipmentPlanId, remark = '', userId = null, userName = '系统后台') {
  const params = new URLSearchParams({
    shipmentPlanId,
    remark: remark || '',
    userName: userName || '系统后台'
  })
  if (userId) {
    params.set('userId', userId)
  }
  return request(`${API_PATHS.CONFIRM_NEW_PDA_SHIPMENT_PLAN_PACKING}?${params.toString()}`, {
    method: 'POST'
  })
}

/**
 * 获取新版PDA贴箱唛列表（按发货单/货件）
 */
export async function getNewPdaBoxLabelListPaged(params) {
  return request(API_PATHS.GET_NEW_PDA_BOX_LABEL_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 确认新版PDA单个箱规贴箱唛
 */
export async function confirmNewPdaDeliveryOrderBoxSizeLabel(ids, userId = null, userName = '系统后台') {
  return request(API_PATHS.CONFIRM_NEW_PDA_DELIVERY_ORDER_BOX_SIZE_LABEL, {
    method: 'POST',
    body: JSON.stringify({
      ids,
      userId: userId || null,
      userName: userName || '系统后台'
    })
  })
}

/**
 * 确认新版PDA发货单贴箱唛
 */
export async function confirmNewPdaBoxLabel(ids, userId = null, userName = '系统后台') {
  return request(API_PATHS.CONFIRM_NEW_PDA_BOX_LABEL, {
    method: 'POST',
    body: JSON.stringify({
      ids,
      userId: userId || null,
      userName: userName || '系统后台'
    })
  })
}

/**
 * 获取新版发货单作业列表（New-配货）
 */
export async function getNewDeliveryOrderListPaged(params) {
  return request(API_PATHS.GET_NEW_DELIVERY_ORDER_LIST_PAGED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 确认新版发货单配货
 */
export async function confirmNewDeliveryOrderPicking(ids) {
  return request(API_PATHS.CONFIRM_NEW_DELIVERY_ORDER_PICKING, {
    method: 'POST',
    body: JSON.stringify({
      ids
    })
  })
}

/**
 * 确认打包
 */
export async function confirmPackaging(params) {
  return request(API_PATHS.CONFIRM_PACKAGING, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取箱规列表
 */
export async function getPlanBoxSize(planItemIds) {
  return request(API_PATHS.GET_PLAN_BOX_SIZE, {
    method: 'POST',
    body: JSON.stringify(planItemIds)
  })
}

/**
 * 创建箱规
 */
export async function createBoxSize(params) {
  return request(API_PATHS.CREATE_BOX_SIZE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 修改箱规
 */
export async function modifyBoxSize(params) {
  return request(API_PATHS.MODIFY_BOX_SIZE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 删除箱规
 */
export async function removeBoxSize(id) {
  const url = `${API_PATHS.REMOVE_BOX_SIZE}?id=${encodeURIComponent(id)}`
  return request(url, { method: 'GET' })
}

/**
 * 上传图片
 */
export async function uploadImages(file) {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch(BASE_URL + API_PATHS.UPLOAD_IMAGES, {
    method: 'POST',
    body: formData
  })

  if (!response.ok) {
    throw new Error('图片上传失败')
  }

  const text = await response.text()
  return text ? JSON.parse(text) : { success: true }
}

/**
 * 获取采购单盘点列表
 */
export async function getPurchaseOrderStockTake(params) {
  return request(API_PATHS.GET_PURCHASE_ORDER_STOCK_TAKE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 上传盘点图片
 */
export async function uploadInventoryImages(file) {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch(BASE_URL + API_PATHS.UPLOAD_INVENTORY_IMAGES, {
    method: 'POST',
    body: formData
  })

  if (!response.ok) {
    throw new Error('图片上传失败')
  }

  const text = await response.text()
  return text ? JSON.parse(text) : { success: true }
}

/**
 * 上传到货异常图片（支持单个文件）
 */
export async function uploadArrivalExceptionImage(file) {
  const formData = new FormData()
  formData.append('files', file)

  const response = await fetch(BASE_URL + API_PATHS.UPLOAD_INVENTORY_IMAGES, {
    method: 'POST',
    body: formData
  })

  if (!response.ok) {
    throw new Error('图片上传失败')
  }

  const text = await response.text()
  return text ? JSON.parse(text) : { success: true }
}

/**
 * 提交盘点
 */
export async function submitStockTake(params) {
  return request(API_PATHS.SUBMIT_STOCK_TAKE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取商品盘点列表（无采购单）
 */
export async function getCommodityStockTake(params) {
  return request(API_PATHS.GET_COMMODITY_STOCK_TAKE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 提交商品盘点（无采购单）
 */
export async function commoditySubmitStockTake(params) {
  return request(API_PATHS.COMMODITY_SUBMIT_STOCK_TAKE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取扫描盘点列表（按货位号查询）
 */
export async function getGoodsNumberList(goodsNumber) {
  const url = `${API_PATHS.GET_GOODS_NUMBER_LIST}?goodsNumber=${encodeURIComponent(goodsNumber)}`
  return request(url, { method: 'GET' })
}

/**
 * 获取扫描盘点详情
 */
export async function getGoodsNumberDetails(id) {
  const url = `${API_PATHS.GET_GOODS_NUMBER_DETAILS}?id=${encodeURIComponent(id)}`
  return request(url, { method: 'GET' })
}

/**
 * 确认单个箱子贴箱唛
 */
export async function confirmBoxSizeAttached(id) {
  const url = `${API_PATHS.CONFIRM_BOX_SIZE_ATTACHED}?id=${encodeURIComponent(id)}`
  return request(url, { method: 'GET' })
}

/**
 * 确认贴箱唛（批量）
 */
export async function confirmAttached(params) {
  return request(API_PATHS.CONFIRM_ATTACHED, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取打包详情
 */
export async function getPackagingDetails(id) {
  return request(`${API_PATHS.GET_PACKAGING_DETAILS}?id=${id}`, {
    method: 'GET'
  })
}

export async function saveskucheckimages(params) {
  return request(API_PATHS.SAVE_SKU_CHECK_IMAGES, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}
export async function pushDingImages(id) {
  return request(`${API_PATHS.PUSH_IMAGES}?id=${id}`, {
    method: 'GET'
  })
}
/**
 * 获取货件列表
 */
export async function getShipPlanItem(id) {
  return request(`${API_PATHS.GET_SHIP_PLAN_ITEM}?id=${id}`, {
    method: 'GET'
  })
}

/**
 * 货件确认打包
 */
export async function shipmentConfirmPack(params) {
  return request(API_PATHS.SHIPMENT_CONFIRM_PACK, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 上传运费提报图片
 */
export async function uploadFreightImages(file) {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch(BASE_URL + API_PATHS.UPLOAD_FREIGHT_IMAGES, {
    method: 'POST',
    body: formData
  })

  if (!response.ok) {
    throw new Error('图片上传失败')
  }

  const text = await response.text()
  return text ? JSON.parse(text) : { success: true }
}

/**
 * 创建运费提报单
 */
export async function createFreightReport(params) {
  return request(API_PATHS.CREATE_FREIGHT_REPORT, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function getReturnedFreightReports(userId) {
  return request(`/api/app/products/productfreightcostreport/getreturned?userId=${encodeURIComponent(userId)}`, {
    method: 'GET'
  })
}

/**
 * 获取业务库存列表
 */
export async function getlistdetailspaged(params) {
  return request('/api/app/chains/chainwarehouseinventory/getlistdetailspaged', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取备样列表（分页）
 */
export async function getBeiyangListPaged(params) {
  return request(API_PATHS.GET_BEIYANG_LIST, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 获取备样详情
 */
export async function getBeiyangDetail(id) {
  return request(`${API_PATHS.GET_BEIYANG_DETAIL}?id=${encodeURIComponent(id)}`, {
    method: 'GET'
  })
}

/**
 * 确认备样
 */
export async function confirmPrepareSample(params) {
  return request(API_PATHS.CONFIRM_PREPARE_SAMPLE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 确认收样（仓库完成）
 */
export async function confirmWarehouseComplete(params) {
  return request(API_PATHS.CONFIRM_WAREHOUSE_COMPLETE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

/**
 * 确认还样（摄影师还样）
 */
export async function confirmPhotographyRevertSample(params) {
  return request(API_PATHS.CONFIRM_PHOTOGRAPHY_REVERT_SAMPLE, {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function getChangshaPhotographyList(params) {
  const userInfo = getUserInfo()
  return request(API_PATHS.GET_CHANGSHA_PHOTOGRAPHY_LIST, { body: JSON.stringify({ region: 'changsha', onlyVisibleToCurrentPhotographer: true, currentPhotographerId: userInfo.userId || null, ...params }) })
}

export async function getChangshaPhotographyDetail(id) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.GET_CHANGSHA_PHOTOGRAPHY_DETAIL}?id=${encodeURIComponent(id)}`, 'currentPhotographerId'), { method: 'GET' })
}

export async function confirmChangshaPhotographyReceive(id) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.CONFIRM_CHANGSHA_PHOTOGRAPHY_RECEIVE}?id=${encodeURIComponent(id)}`), { body: JSON.stringify({}) })
}

export async function startChangshaPhotographyShooting(id) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.START_CHANGSHA_PHOTOGRAPHY_SHOOTING}?id=${encodeURIComponent(id)}`), { body: JSON.stringify({}) })
}

export async function registerChangshaPhotographyTransfer(params) {
  const userInfo = getUserInfo()
  return request(API_PATHS.REGISTER_CHANGSHA_PHOTOGRAPHY_TRANSFER, { body: JSON.stringify({ ...params, operatorId: userInfo.userId || null, operatorName: userInfo.userName || '' }) })
}

export async function markChangshaPhotographyShot(id) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.MARK_CHANGSHA_PHOTOGRAPHY_SHOT}?id=${encodeURIComponent(id)}`), { body: JSON.stringify({}) })
}

export async function confirmChangshaPhotographyUpload(id) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.CONFIRM_CHANGSHA_PHOTOGRAPHY_UPLOAD}?id=${encodeURIComponent(id)}`), { body: JSON.stringify({}) })
}

export async function uploadChangshaPhotographyFiles(id, formData) {
  return request(withChangshaPhotographyOperator(`${API_PATHS.UPLOAD_CHANGSHA_PHOTOGRAPHY_FILES}?id=${encodeURIComponent(id)}`), { body: formData })
}

function withChangshaPhotographyOperator(url, idParameterName = 'operatorId') {
  const userInfo = getUserInfo()
  const separator = url.includes('?') ? '&' : '?'
  const params = new URLSearchParams()
  if (userInfo.userId) params.set(idParameterName, userInfo.userId)
  if (idParameterName === 'operatorId' && userInfo.userName) params.set('operatorName', userInfo.userName)
  return params.toString() ? `${url}${separator}${params.toString()}` : url
}

export default {
  getlistdetailspaged,
  getBeiyangListPaged,
  getBeiyangDetail,
  confirmPrepareSample,
  confirmWarehouseComplete,
  confirmPhotographyRevertSample,
  getChangshaPhotographyList,
  getChangshaPhotographyDetail,
  confirmChangshaPhotographyReceive,
  startChangshaPhotographyShooting,
  registerChangshaPhotographyTransfer,
  markChangshaPhotographyShot,
  uploadChangshaPhotographyFiles,
  confirmChangshaPhotographyUpload,
  getPdaListPaged,
  getPutShelfList,
  getPurchaseOrderByNo,
  removePdaArrivalItem,
  fbaPurchaseArrival,
  getFbaAdjustmentSource,
  getFbaAdjustmentList,
  getFbaAdjustmentSku,
  searchFbaAdjustmentSku,
  createFbaAdjustment,
  confirmPutShelf,
  getDingUserInfo,
  getGoodsLocationAll,
  getLocationTransferList,
  transferLocationFull,
  getDesignatedStatusData,
  confirmAllocated,
  getNewPdaPickingListPaged,
  confirmNewPdaPicking,
  getNewPdaSmallLabelCheckListPaged,
  getNewPdaSmallLabelCheckDetail,
  submitNewPdaSmallLabelFeedback,
  getNewPdaSecondaryPackagingListPaged,
  getNewPdaSecondaryPackagingDetail,
  submitNewPdaSecondaryPackagingFeedback,
  saveNewPdaSkuCheckImages,
  pushNewPdaSkuCheckImages,
  getNewPdaPackingListPaged,
  getNewPdaDeliveryOrderBoxSize,
  saveNewPdaDeliveryOrderBoxSize,
  confirmNewPdaPacking,
  getNewPdaShipmentPlanBoxSize,
  getNewPdaShipmentPlanBoxRuleContext,
  previewNewPdaBoxRule,
  saveNewPdaShipmentPlanBoxSize,
  confirmNewPdaShipmentPlanPacking,
  getNewPdaBoxLabelListPaged,
  confirmNewPdaDeliveryOrderBoxSizeLabel,
  confirmNewPdaBoxLabel,
  getNewDeliveryOrderListPaged,
  confirmNewDeliveryOrderPicking,
  confirmPackaging,
  getPlanBoxSize,
  createBoxSize,
  modifyBoxSize,
  removeBoxSize,
  uploadImages,
  getPurchaseOrderStockTake,
  uploadInventoryImages,
  uploadArrivalExceptionImage,
  submitStockTake,
  getCommodityStockTake,
  commoditySubmitStockTake,
  getGoodsNumberList,
  getGoodsNumberDetails,
  confirmBoxSizeAttached,
  confirmAttached,
  getPackagingDetails,
  saveskucheckimages,
  getShipPlanItem,
  shipmentConfirmPack,
  uploadFreightImages,
  createFreightReport,
  pushDingImages
}
